import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormControl } from '@angular/forms';
import { CheckboxItem } from '../checkBoxItem';

@Component({
  selector: 'app-checkboxgroup',
  templateUrl: './checkboxgroup.component.html',
  styleUrls: ['./checkboxgroup.component.css']
})
export class CheckboxgroupComponent implements OnInit, OnChanges {
  @Input() options = Array<CheckboxItem>();
  @Output() toggle = new EventEmitter<any[]>();

  form = new FormGroup({
    items: new FormArray([])
  });
  
  constructor() { }

  ngOnInit() {
    this.form.valueChanges.subscribe(value => {
      const optionsChecked = new Array<any>();
      for (let index = 0; index < this.items.length; index++) {
        const isOptionChecked = this.items.get(index.toString()).value;
        if (isOptionChecked) {
          const currentOptionValue = this.options[index].value;
          optionsChecked.push(currentOptionValue);
        }
      }
      this.toggle.emit(optionsChecked);
    });
  }

  ngOnChanges() {
    if (this.items.length === 0) {
      this.options.forEach(x => {
        this.items.push(new FormControl(false));
      });
    }
    //this.selectedValues.forEach(value => {
    //  const index: number = this.options.findIndex(opt => opt.value === value);
    //  if (index >= 0) {
    //    this.items.get(index.toString()).setValue(true);
    //  }
    //});
  }

  get items(): FormArray {
    return this.form.get('items') as FormArray;
  }

}
